import { useCallback, useMemo } from 'react';
import { usePlaylist } from '../savedItemsQueries';
// @ts-expect-error Could not find a declaration file for module
import useFilterParams from '../../../hooks/useFilterParams';
import UsageTracker from '../../../utils/UsageTracker';
import { getPlaylistUrl } from '../../../utils/RoutingUtils';
import { useLocation } from 'react-router-dom';
import PlaylistThumbnailOverlayed from '../../../components/TrackCard/Thumbnail/PlaylistThumbnailOverlayed';
import ContentCard from '../../../components/TrackCard/ContentCard';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const PlaylistCard = ({
  playlistId,
  isFlushOnMobile = true,
  position,
  appearsIn,
  isGhost,
  body,
  thumbnailHeader,
  loadingState,
  onClick,
  use,
  showDescription = true
}) => {
  const {
    playlist
  } = usePlaylist(playlistId);
  const filterParams = useFilterParams();
  const {
    search
  } = useLocation();
  const onClickHandler = useCallback(() => {
    if (!playlist) return;
    const {
      name
    } = playlist;
    UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: 'PLAYLIST',
      appearsIn,
      playlistId,
      position,
      name,
      filters: JSON.stringify(filterParams),
      style: 'default'
    });
    if (onClick) onClick();
  }, [appearsIn, filterParams, onClick, playlist, playlistId, position]);
  const to = useMemo(() => {
    if (!playlist) return null;
    const {
      id
    } = playlist;
    return {
      pathname: getPlaylistUrl(id),
      search // send language query params when isStarted = true?
    };
  }, [playlist, search]);
  if (!playlist) return loadingState ? /*#__PURE__*/_jsx(_Fragment, {
    children: loadingState
  }) : null;
  const {
    name,
    description
  } = playlist;
  return /*#__PURE__*/_jsx(ContentCard, {
    body: body,
    "data-test-meta": playlistId,
    "data-test-type": "playlist",
    description: showDescription ? description : undefined,
    isFlushOnMobile: isFlushOnMobile,
    isGhost: isGhost,
    name: name,
    onClick: onClickHandler,
    thumbnailOverlayed: /*#__PURE__*/_jsx(PlaylistThumbnailOverlayed, {
      header: thumbnailHeader,
      isGhost: isGhost,
      playlistId: playlistId
    }),
    to: to,
    use: use
  });
};
export default PlaylistCard;